<template>
  <template class="" v-for="(item, index) in approveList" :key="index">
    <a-form-item :label="item.nodeName">
      <div class="df vertical">
        <div class="approver">{{ item.approver }}</div>


        <a-tag v-if="item.approved === null" color="#108ee9">待审核</a-tag>
        <a-tag v-else-if="item.approved === false" color="#f50">
          <span v-if="item.approvalTime">
            {{ timeStampToTime(item.approvalTime, "upload") }}</span
          >
           审核未通过</a-tag
        >
        <a-tag v-else-if="item.approved === true" color="#87d068">
          <span v-if="item.approvalTime">
            {{ timeStampToTime(item.approvalTime, "upload") }}</span
          > 审核通过</a-tag
        >
        <a-textarea
          :disabled="true"
          v-model:value="item.notes"
          auto-size
          style="width: 440px"
          v-if="item.notes"
        >
        </a-textarea>
      </div>
    </a-form-item>
  </template>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { getEngineeringDepartment } from "@/utils/base/staff";
import { timeStampToTime } from "@/utils/index";
import staff from "@/components/chooseStaff/staff.vue";

export default defineComponent({
  components: { staff },
  props: {
    echoApprove: Object,
    echoRecord: Object,
  },
  setup(props) {
    const user = useStore().state.user.user;
    const route = useRoute();

    // 项目负责人
    const projectLeaderName = route.query.projectLeader.replace(/[\d]+/g, "");
    // 组长
    const groupLeaderName = user.isDL ? user.nickName : user.reportTo;
    // 工程师
    const engineerName = user.nickName;

    /**
     * approved: 是否通过
     * approver: 审批人
     * notes: 审批备注
     */
    const approveList = reactive([
      {
        nodeName: "工程师发起",
        approved: null,
        approver: engineerName,
        id: null,
        notes: null,
        processId: null,
      },
      {
        nodeName: "组长审批",
        approved: null,
        approver: groupLeaderName,
        id: null,
        notes: null,
        processId: null,
      },
      {
        nodeName: "PL审批",
        approved: null,
        approver: projectLeaderName,
        id: null,
        notes: null,
        processId: null,
      },
      {
        nodeName: "发起评审",
        approved: null,
        approver: engineerName,
        id: null,
        notes: null,
        processId: null,
      },
      {
        nodeName: "组长会签",
        approved: null,
        approver: groupLeaderName,
        id: null,
        notes: null,
        processId: null,
      },
      {
        nodeName: "工程(抄送采购)",
        approved: null,
        approver: null,
        id: null,
        notes: null,
        processId: null,
      },
    ]);

    const getChooseStaff = (e, index) => {
      const { idList, staffName, staffUserName, structureName } = e;
      console.log(e, index);
    };

    const setApprovelist = () => {
      if (user.isDL && props.echoRecord.id === null) {
        approveList.splice(0, 1);
      }
      getEngineeringDepartment("工程部")
        .then((res) => {
          approveList[approveList.length - 1].approver = res.nickName;
        })
        .catch((err) => {
          console.log(err);
        });
    };
    watch(
      () => props.echoApprove,
      (val) => {
        if (val) {
          val.forEach((item, index) => {
            approveList[index].approved = item.approved;
            approveList[index].approver = item.approver;
            approveList[index].notes = item.notes;
            approveList[index].approvalTime = item.approvalTime;
          });
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      getChooseStaff,
      approveList,
      timeStampToTime,
      setApprovelist,
    };
  },
});
</script>

<style lang="less" scoped>
.approver {
  width: 60px;
  margin-left: 10px;
}
</style>
